import {Form, Formik} from 'formik';
import Link from 'next/link';
import {useTranslation} from 'next-i18next';
import PropTypes from 'prop-types';

import {SUPPORT_EMAIL} from '@/src/app/constants/emails';
import useRoutePaths from '@/src/hooks/useRoutePaths';
import TextLocal from '@/src/textLocal/containers/TextLocal';

import {Button, Checkbox, Text} from '../../../ui';
import css from '../styles/DeleteAccountPopupLayout.module.css';

const DeleteAccountPopupLayout = ({onSubmitClick, onCancelClick}) => {
  const {t} = useTranslation('common');
  const {PRIVACY_POLICY_ROUTE} = useRoutePaths();

  return (
    <div className={css.popup}>
      <div className={css.heading}>
        <Text
          fontFamily={Text.FONT_FAMILY.RUBIK}
          fontSize={Text.FONT_SIZE.SIZE_24}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
        >
          <TextLocal id={'profile.we-regret-you-want-to-deactivate'} />
        </Text>
      </div>
      <div className={css.bodyText}>
        <Text
          fontSize={Text.FONT_SIZE.SIZE_14}
          color={Text.COLOR.GREY}
          lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_21}
        >
          <TextLocal id={'profile.save-your-profile'} />
        </Text>
        <div>
          <Text
            fontSize={Text.FONT_SIZE.SIZE_14}
            color={Text.COLOR.GREY}
            lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_21}
          >
            <TextLocal id={'profile.cancel-any-time'} />
          </Text>
          <ul className={css.textList}>
            <li>
              <Text
                fontSize={Text.FONT_SIZE.SIZE_14}
                color={Text.COLOR.GREY}
                lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_21}
                display={Text.DISPLAY.INLINE}
              >
                <TextLocal id={'profile.we-confirm-your-unsubscription'} />
              </Text>
            </li>
            <li>
              <Text
                fontSize={Text.FONT_SIZE.SIZE_14}
                color={Text.COLOR.GREY}
                lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_21}
                display={Text.DISPLAY.INLINE}
              >
                <TextLocal id={'profile.or-by-sending-an-email'} />
              </Text>
              <Text
                fontSize={Text.FONT_SIZE.SIZE_14}
                color={Text.COLOR.BLUE}
                fontWeight={Text.FONT_WEIGHT.BOLD}
                display={Text.DISPLAY.INLINE}
              >
                <a
                  href={`mailto:${SUPPORT_EMAIL}`}
                  aria-label={`email to support`}
                >
                  {SUPPORT_EMAIL}
                </a>
              </Text>
              <Text
                fontSize={Text.FONT_SIZE.SIZE_14}
                color={Text.COLOR.GREY}
                lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_21}
                display={Text.DISPLAY.INLINE}
              >
                <TextLocal id={'profile.or-by-sending-an-email-end'} />
              </Text>
            </li>
          </ul>
        </div>
        <div>
          <Text
            fontSize={Text.FONT_SIZE.SIZE_14}
            color={Text.COLOR.GREY}
            lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_21}
            display={Text.DISPLAY.INLINE}
          >
            <TextLocal id={'profile.the-revocation-of'} />
          </Text>
          <Text
            fontSize={Text.FONT_SIZE.SIZE_14}
            color={Text.COLOR.BLUE}
            fontWeight={Text.FONT_WEIGHT.BOLD}
            display={Text.DISPLAY.INLINE}
          >
            <Link href={PRIVACY_POLICY_ROUTE.getLink()}>
              <a>
                <TextLocal id={'profile.here'} />
              </a>
            </Link>
          </Text>
        </div>
      </div>
      <Formik
        initialValues={{remove_immediately: false}}
        onSubmit={onSubmitClick}
      >
        <Form>
          <div className={css.checkboxBlock}>
            <Checkbox
              label={t('profile.i-allow-storing-my-data')}
              name={'remove_immediately'}
            />
          </div>
          <div className={css.buttonsBlock}>
            <div className={css.button}>
              <Button
                color={Button.COLOR.PRIMARY}
                height={Button.HEIGHT.REGULAR}
                onClick={onCancelClick}
              >
                <TextLocal id={'create-course.cancel'} />
              </Button>
            </div>
            <div className={css.button}>
              <Button
                color={Button.COLOR.RED}
                height={Button.HEIGHT.REGULAR}
                type={Button.TYPES.SUBMIT}
              >
                <TextLocal id={'profile.delete-account'} />
              </Button>
            </div>
          </div>
        </Form>
      </Formik>
    </div>
  );
};

DeleteAccountPopupLayout.propTypes = {
  onSubmitClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
};

export default DeleteAccountPopupLayout;
